import { Component, OnInit, Output, HostListener, ViewChild, OnDestroy, AfterViewInit } from "@angular/core";
import { NavigationStart, Router, RouterOutlet } from "@angular/router";
import { componentRoutes } from "./route-mapping";
import { PopupContentComponent } from "./popup-content/popup-content.component";
import { ServiceStock } from "./service-stock.service";
import { AlertsComponent } from "./alerts/alerts.component";
import { Platform } from "@ionic/angular";
import { DeviceDetectorService, DeviceType } from "ngx-device-detector";
import { PopupModalComponent } from "./popup-modal/popup-modal.component";
import { ActivityMonitor } from "./activitymonitor.service";
import { FileTransfer } from "@ionic-native/file-transfer/ngx";
import { UXDimensions, UXUtils } from "./utils/ux";
import { FcmNotificationService } from "./fcm-notification.service";
import { ObservableService } from "./observable.service";
import { filter, fromEvent, Observable } from "rxjs";
import { SpinnerService } from './services/spinner/spinner.service';
import { CommonService } from "./common.service";
import { Directionality } from "@angular/cdk/bidi";
import { HttpClient } from "@angular/common/http";
import { ErrorValidatorService } from "./common/directives/error-handler/error-validator.service";
import { LoginService } from "./pre-login/login/services/login.service";
import { PreLoginService } from "./pre-login/pre-login.service";
import { UserDetailsService } from './services/transfers/user-details.service';
import { UserService } from "./user.service";
import { ResponsiveService } from "./responsive.service";
import { MatDialog } from "@angular/material/dialog";

declare let window: any;
declare let $: any;

const successCallback = (result) => {
  console.log(result); // true - enabled, false - disabled
};

const errorCallback = (error) => {
  console.log(error);
};

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("appAlerts") appAlerts: AlertsComponent;

  greenifyExceed$: Observable<any>

  // switchLanguage(language: string) {
  //   this.services.translate.use(language);
  // }

  loaderTemplate: string = '<img width="60px" src="./assets/images/spinner.gif" />';
  isMobile: boolean = false;
  showResumeWarning: boolean = false;
 
  public loading$: Observable<boolean> = this.loadingSpinner.loading$;

  documentDirection: string = 'ltr';

  constructor(
    public loadingSpinner: SpinnerService,
    private _errorMessage: ErrorValidatorService,
    public services: ServiceStock,
    private router: Router,
    private platform: Platform,
    private deviceService: DeviceDetectorService,
    private activityMonitor: ActivityMonitor,
    private fcmService: FcmNotificationService,
    public observableService: ObservableService,
    protected _commonService: CommonService,
    private dir: Directionality,
    private httpClient: HttpClient,
    private _userDetailsService: UserDetailsService,
    private _preLoginService: PreLoginService,
    private _userService: UserService,
    private _responsive:ResponsiveService,
    private _dialog: MatDialog,


    ) {
    
      this._commonService.deviceInfo = this._commonService.getDeviceDetails()
      
      
      router.events.subscribe(val => {
        if(this._commonService.isDesktop()){
          history.pushState(null, '', location.href);
        }
        window.onpopstate = function () {
          history.go(1);
        };
      });

    this._commonService.isRtl = dir.value === 'rtl';
    dir.change.subscribe((direction) => {
      this._commonService.isRtl = direction === 'rtl';
      this.documentDirection = (this._commonService.isRtl) ? 'rtl' : 'ltr';
    });

    window["mainScope"] = this.services;
    window.addEventListener("onlogout", this.onLogout, false);
    window.addEventListener("onPromptIdleTimeout", this.onPromptIdleTimeout, false);
    window.addEventListener("onSessionTimeout", this.onSessionTimeout, false);
    window.addEventListener("startSession", this.startSession.bind(this), false);
    window.addEventListener("resumeLastAction", this.onResumeLastAction.bind(this), false);
   
    this.isMobile = this.deviceService.isMobile();

    for (var i = 0; i < componentRoutes.length; i++) {
      let route = componentRoutes[i];
      let path = route.path;
      let loadChildren = route.loadChildren;

      for (var j = 1; j < 3; j++) {
        let pushValue = {};
        pushValue["path"] = path;
        pushValue["outlet"] = "popUp" + j;
        pushValue["component"] = PopupContentComponent;
        pushValue["children"] = [
          {
            path: "popup",
            loadChildren: loadChildren,
          },
        ];
        this.router.config.unshift(pushValue);
      }
    }
    let lang = localStorage.getItem('lang') || "En";
    this._commonService.switchLanguage(lang);
    this.services.http.currentLanguage = lang;
  }

  private _screenReload() {
    this.router.events.pipe(filter((ev) => ev instanceof NavigationStart)).subscribe((event) => {
      if (!this.router.navigated && this._userDetailsService.token) {
        this._preLoginService.refreshTokenService?.stop();
        this._preLoginService.logout();
      }
      // else{
      //   this.services.router.navigate(["welcome", "appnavigator"]);
      // }
    });
  }
  //tfacompletedValue : any;

  ngOnInit() {

    this._commonService.getErrorMessage('En');
    this._screenReload();
    this._commonService.deviceInfo = this._commonService.getDeviceDetails();
    /*SANTHOSH 08/DEC/2021 BEGIN */
    this.services.initializeUIClass();
    this._commonService.initializeUIClass();
    this.greenifyExceed$ = this.observableService.getExceedPopUp()

    if (this.services.isDesktop()) {
      $('html').addClass('desktop');
      $('html').attr('id', 'desktop');
      UXDimensions.DEVICE_WIDTH = 1280.0;
      UXDimensions.DEVICE_HEIGHT = 800.0;
      UXDimensions.SCREEN_WIDTH = window.innerWidth;
      UXDimensions.SCREEN_HEIGHT = window.innerHeight;
    } else {
      UXDimensions.DEVICE_WIDTH = 375.0;
      UXDimensions.DEVICE_HEIGHT = 812.0;
      console.log("PLATFORM: ", this.platform);
      if (this.platform.is('android')) {
        $('html').attr('id', 'android');
      }
    }
    /*SANTHOSH 08/DEC/2021 END */
    document.addEventListener("resume", () => {
      if (window.plugins && window.plugins.preventscreenshot) {
        window.plugins.preventscreenshot.enable(successCallback, errorCallback);
      }

      this.activityMonitor.checkAndLogout();
    },
      false
    );
    document.addEventListener("pause", () => {
      if (window.plugins && window.plugins.preventscreenshot) {
        window.plugins.preventscreenshot.disable(successCallback, errorCallback);
      }
    },
      false
    );

    this.services.alert.checkForAlerts.subscribe((data) => {
      this.appAlerts.showAlert(data["alertType"], data["alertMsg"], data["timeout"]);
    });

    // if(this._responsive.isHybrid()){
    //   this._preLoginService.checkForUpdate().subscribe({
    //     next:(res)=>{
    //       console.log("checkForUpdate", res);
    //     }
    //   });
    // }
    
    //trigger push notification listener
    this.fcmService.checkFCMPermission();
  }

  closeExceedPopUp() {
    this.observableService.setExceedPopUp(null)
  }

  ngAfterViewInit() {
    /**
   * if the network down - show offline popup
   * if the network up - show online popup
   */
    fromEvent(window,'online').subscribe({
      next : (res) => {
        this._commonService.isNetworkDown = false;
        this._preLoginService.showOnlineOfflinePopup()
      }
    })
    fromEvent(window,'offline').subscribe({
      next : (res) => {
        this._commonService.isNetworkDown = true;
        this._preLoginService.showOnlineOfflinePopup()
      }
    })

    this._preLoginService.checkApplicationStatus().subscribe({
      next: res => {
        if (res?.httpStatus == 200) {
          this._preLoginService.serviceUp = true;
        }
        else {
          this._preLoginService.logout(['system-down']);;
        }
      },
      error: error => {
        this._preLoginService.logout(['system-down']);
      }
    });
   }

  /*SANTHOSH 30/09/2021 BEGIN*/

  ngOnDestroy() {
    this.activityMonitor.stopMonitor();
    console.log("Destroyed");
  }
  /*SANTHOSH 30/09/2021 END*/
  @HostListener("window:beforeunload", ["$event"])
  beforeunloadHandler(event) {
    if (this.services.http.tfaapplet != undefined && this.services.http.tfaapplet != null) {
      (window as any).logoutFromSmartCard(this.services.http.tfaapplet);
    }
  }

  onLogout() {
    var services = window["mainScope"];
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("dynamicSubText", "Are you sure you want to logout?");
    inputMap.set("primaryBtnLable", "Yes");
    inputMap.set("secondaryBtnLable", "No");
    inputMap.set("component", "LogOutPopUp");
    const modalRef = services.modal.open(PopupModalComponent, { windowClass: "modal-width-sm" });
    var onModalClose = async (reason) => {
      reason == 0 || reason == 1 ? await services.routing.removeOutlet() : undefined;
      if (services.dataStore.getData("doLogOut")) {
        this._preLoginService.logout()
      }
    };
    modalRef.result.then(onModalClose, onModalClose);
    modalRef.componentInstance.rotueToComponent(inputMap);
    services.dataStore.setModalReference(services.routing.currModal, modalRef);
  }

  async onPromptIdleTimeout() {
    var services = window["mainScope"];
    let inputMap = new Map();
    inputMap.clear();
    for (var i = services.routing.currModal; i > 0; i--) {
      await services.dataStore.getModalReference(i).componentInstance.closeModal();
    }
    inputMap.set("component", "idleSessionTimeout");
    const modalRef = services.modal.open(PopupModalComponent, { windowClass: "modal-width-sm" });
    var onModalClose = async (reason) => {
      reason == 0 || reason == 1 ? await services.routing.removeOutlet() : undefined;
      if (services.dataStore.getData("forceLogout")) {
        services.http.clearTimer();
        // services.forceLogout();
        this._preLoginService.logout();
      } else if (services.dataStore.getData("keepSessionAlive")) {
        services.getUserImage(null);
        services.dataStore.removeData("keepSessionAlive");
      }
    };
    modalRef.result.then(onModalClose, onModalClose);
    modalRef.componentInstance.rotueToComponent(inputMap);
    services.dataStore.setModalReference(services.routing.currModal, modalRef);
  }

  async onSessionTimeout() {
    var services = window["mainScope"];
    services.http.sessionValid = false;
    for (var i = services.routing.currModal; i > 0; i--) {
      await services.dataStore.getModalReference(i).componentInstance.closeModal();
    }
    // services.router.navigate(["SessionTimedOut"]);
    this._preLoginService.logout(['SessionTimedOut'])
  }

  startSession() {
    /*SANTHOSH 30/09/2021 BEGIN*/
    this.services.dataStore.setUserLoggedIn(true);
    this.activityMonitor.startMonitor(
      () => {
        //TODO DISPLAY PROMPT
        //On User Continute Call this.activityMonitor.continueAndMonitor
        console.log("Display Inactivity Window");
        setTimeout(() => {
          if (this.services.isMobile()) {
            $("#sessonsoon").fadeIn(300);
          } else {
            UXUtils.showPopupInline('sessonsoon')
          }
        });
        this.activityMonitor.updateWarningTime();
      },
      () => {
        if (this.services.dataStore.isUserLoggedIn()) {
          //TODO DISMISS PROMPT and exit
          // this.services.dataStore.setUserLoggedIn(false);
          if (this.services.isMobile()) {
            $("#sessonsoon").fadeOut(300);
          } else {
            UXUtils.hidePopupInline('sessonsoon')
          }

          if (this.services.mobile.isHybrid()) {
            //window.location = "index.html";
            // this.services.forceLogout();
            this.onSessionTimeout();
          } else {
            //this.services.forceLogout();
            this.onSessionTimeout();
            // this.services.router.navigate(["welcome", "appnavigator"]);
          }
        }
      }
    );
    /*SANTHOSH 30/09/2021 END*/
  }

  continueSession() {
    /*SANTHOSH 20-OCT-2021 BEGIN */
    /*this.activityMonitor.continueAndMonitor();*/
    this.activityMonitor.continueSession();
    /*SANTHOSH 20-OCT-2021 END */
    if (this.services.isMobile()) {
      $("#sessonsoon").fadeOut(300);
    } else {
      UXUtils.hidePopupInline('sessonsoon')
    }
  }
  killSession() {
    this.activityMonitor.dissmissAndExit();
  }

  onResumeLastAction() {
    console.log("onResumeLastAction");
    sessionStorage.removeItem('inAccOpeningWay');
    this.showResumeWarning = true;
  }

  gotoAccountOpening() {
    this.showResumeWarning = false;
    this.services.router.navigate(['/home/openAccount']);
  }

  resumeOnboarding() {
    this.showResumeWarning = false;
    sessionStorage.setItem("forceResume", "1");
    this.services.router.navigate(['/home/openAccount']);
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }
  switchLanguage(language: string) {
    this._commonService.switchLanguage(language);
  }

}
